import React from "react";
import {
  Badge,
  Button,
  // Input
} from "antd";

import { useNavigate } from "react-router-dom";

import BagIcon from "../../assets/images/bag.svg";
import logouts from "../../assets/images/logout.svg";
// import GlobeIcon from "../../assets/images/global-refresh.svg";
// import SearchIcon from "../../assets/images/search.svg";
import RewardIcon from "../../assets/images/reward-star.svg";
import { FaHeart } from "react-icons/fa6";
import { logout } from "../../store/services/auth";
import GroupWishlist from "../../assets/images/wishlist-icon.jpg";

import ProfileDropdown from "./ProfileDropdown";
import { getToken } from "../../utils";
import { useAppSelector } from "../../store/hooks";
import NotificationDropdown from "./NotificationDropdown";
import { IoIosLogOut } from "react-icons/io";

const Header: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userWishlistCounts = user?.wishlist?.length;
  const userCartCounts = user?.cart?.length;
  const isUser = getToken();

  const navigate = useNavigate();

  const logoutFun = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="main_header_container layoutPaddingInline">
      <div className="main_header">
        <div className="logo_box">
          <img
            src={require("../../assets/images/logo.png")}
            alt={"Logo"}
            onClick={() => navigate("/")}
          />
        </div>
        <div className="right_side">
          {/* <div className="search_input_box">
            <Input
              placeholder="Search"
              prefix={<img src={SearchIcon} alt={"Search"} />}
              allowClear
            />
          </div> */}
          {!isUser && (
            <>
              <Button
                type="primary"
                className="outlinedButton"
                onClick={() => navigate("/login")}
              >
                <span className="gradientText">Login</span>
              </Button>
              <Button
                type="primary"
                className="primaryButton"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </Button>
            </>
          )}
          {isUser && (
            <>
              <Badge
                size="default"
                count={userCartCounts}
                overflowCount={userCartCounts}
              >
                <img
                  src={BagIcon}
                  alt={"Bag"}
                  onClick={() =>
                    isUser ? navigate("/cart") : navigate("/login")
                  }
                />
              </Badge>
              <Badge size="default" count={0} overflowCount={0}>
                <img
                  src={GroupWishlist}
                  alt={"Group"}
                  onClick={() =>
                    isUser ? navigate("/group-wishlist") : navigate("/login")
                  }
                />
              </Badge>
              <Badge
                size="default"
                count={userWishlistCounts}
                overflowCount={userWishlistCounts}
              >
                <FaHeart
                  size={22}
                  onClick={() =>
                    isUser ? navigate("/wishlist") : navigate("/login")
                  }
                  className="cursor"
                />
              </Badge>
              <ProfileDropdown />
              <div
                onClick={() => {
                  navigate("/settings?active=notifications");
                }}
              >
                <NotificationDropdown />
              </div>

              <div className="reward_box">
                <img
                  src={RewardIcon}
                  alt={"Reward"}
                  style={{ cursor: "none" }}
                  // onClick={() => navigate("/rewards")}
                />
                <h3>{user?.points?.toFixed(2)}</h3>
              </div>
              <img src={logouts} onClick={logoutFun} alt="logout" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
